export const ProMonthlyPlanID = 'pro-monthly';
export const ProYearlyPlanID = 'pro-yearly';
export const ProPlanIDs = [ProMonthlyPlanID, ProYearlyPlanID];

export default (planID?: string | null) => {
  if (!planID) {
    return false;
  }

  return ProPlanIDs.includes(planID);
};
